<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid upload-container p-0 ">
    <div class="row p-0 m-0">
      <div class="col-12 m-0 p-0">
        <div v-bind:id="'pastecontainer' + getId()" style="max-height:20vh; overflow-y:auto; overflow-x:hidden"></div>
        <div class="custom-file col-6">
          <input type="file" @change="selectFile" class="custom-file-input" v-bind:id="'fileupload' + getId()" v-bind:accept="getAccepts()" style="height:initial;">
          <label class="custom-file-label" for="customFile">{{$t('choose_file')}}</label>
          <label class="custom-form-label" v-show="filename != ''" style="overflow:hidden; margin-top: 18px; white-space: nowrap; text-overflow: ellipsis; max-width: 220px; margin-left:-10px;">{{ filename }}</label>
        </div>
      </div>
    </div>

    <div v-bind:id="'propertiesPanel' + getId()" class="mt-0" style="display:none;">
      <upload-file-properties @delete_file="deleteFile" ref="uploadFileProperties"></upload-file-properties>
    </div>
  </div>
</template>

<script>
  import UploadFileProperties from "./upload-file-properties.vue";

  let message = "";
  var fileInfos = [];
  var placeholder = "";
  var buttontext = "";
  var hasErrors = false;
  var pasteresult = "";
  var filename = '';
  //https://stackoverflow.com/questions/1029740/get-mime-type-from-filename-extension


  export default {
    name: "file-selector",
    components: {
      UploadFileProperties,
    },
    props: {
      visibility: {
        required: false,
        type: Boolean,
        default: true
      },
      filter: {
        required: false,
        type: String,
        default: null
      },
      uid: {
        required: false,
        type: String,
        default: null
      },
    },
    data() {
      return {
        placeholder,
        buttontext,
        progressInfos: [],
        selectedFiles: undefined,
        message: "",
        fileInfos,
        hasErrors,
        pasteresult,
        isOpen: false,
        categoryid: 0,
        id: 0,
        filename: '',
      };
    },
    methods: {
      deleteFile(fileId) {
        var thiscontext = this;
        bootbox.confirm("Are you sure you want to delete file?", function (result) {
          if (result) {
            thiscontext.$refs.uploadFileProperties.displayDefaultContent();
            thiscontext.$refs.uploadFileProperties.showDelete = false;
            thiscontext.$emit('delete_file', fileId);
          }
        });
      },
      getId() {
        return this._uid;
      },
      getAccepts() {
        if (typeof this.filter != "undefined" && this.filter != null) {
          var dottedFilter = "";
          var filterArray = this.filter.split(',');
          var limiter = "";
          for (var i = 0; i < filterArray.length; i++) {
            dottedFilter += limiter + "." + filterArray[i];
            limiter = ",";
          }
          return dottedFilter;
        }
        return "";
      },
      selectFile(event) {
        this.progressInfos = [];
        this.selectedFiles = event.target.files;
        this.filename = this.selectedFiles[0].name;
        this.$forceUpdate();
      },
      clear() {
        this.message = "";
        this.filename = '';
        this.progressInfos = [];
        $(".fileControl").val('');
        this.selectedFiles = [];
      },



      getMimeTypeFromUrl(url) {
        if (url.indexOf("mimetype=") > 0) {
          return url.split("mimetype=")[1];
        }
        var extension = this.getUrlExtension(url);
        if (extension != null && extension != "" && extension != url) {
          var mime = this.getMimeType(extension);
          if (mime != null)
            return mime;
        }
        return "application/octet-stream";
      },

      getUrlExtension(url) {
        return url.split(/[#?]/)[0].split('.').pop().trim();
      },

      getMimeType(extension) {
        if (extension == null) {
          alert("extension");
        }

        if (!extension.indexOf(".") == 0) {
          extension = "." + extension;
        }

        var result = this._mappings[extension];
        if (result != null && typeof (result) != "undefined")
          return result;
        return null;
      },

      setUid(v) {
        this.uid = v;
      },

      hidePropertiespannel() {
        $('#propertiesPanel' + this.getId()).hide();
        this.$forceUpdate();
      },

      loadFile(selectedFileUrl, selectedFileName, showDelete) {
        this.clear();
        $('#propertiesPanel' + this.getId()).show();
        var url = selectedFileUrl;
        var name = selectedFileName;
        if (url !== "" && url !== null && url !== undefined) {
          var settings = this.getSettings(url);
          this.$refs.uploadFileProperties.loadFile(url, name, settings);
          this.$refs.uploadFileProperties.showDelete = showDelete;
        }
      },
      getSettings(url) {
        //Property
        var settings = {
          "Property": [{ "mimetype": url }]
        }
        return settings;
      },
      reset() {
        this.progressInfos = [];
        this.selectedFiles = undefined;
        this.message = "";
        this.fileInfos;
        this.hasErrors = false;
        this.id = 0;
        this.filename = '';
      }
    },

    watch: {
      id: function (newVal, oldVal) {

      },
    },
    mounted() {
      this.buttontext = this.$t('upload');
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/upload/file-selector.vue